import React, { useContext as useContextCore } from 'react'
import { usePaymentMethodPanelContext } from '../Context'
import { useCheckoutContext } from '../../../index'

const context = React.createContext(null)
const CoreProvider = context.Provider

export const Provider = ({ children, ...props }) => {
  const context = useCheckoutContext()

  const { document } = context.orderDocumentResult

  const { isPartial, setIsPartial, balance } = usePaymentMethodPanelContext()

  const [line_items, setLine_items] = React.useState([])

  const [lineItem, setLineItem] = React.useState<{ price?: number; isPartial?: boolean; name: string }>({
    name: 'Partial payment',
  })

  React.useEffect(() => {
    // Functional update so this effect only needs to depend on balance/document?.payments, not
    // lineItem itself — depending on lineItem here would refire this same setLineItem every time it runs.
    setLineItem((prev) => ({ ...prev, price: balance }))
  }, [balance, document?.payments])

  React.useEffect(() => {
    if (isPartial) setLine_items([lineItem])
  }, [lineItem, isPartial])

  React.useEffect(() => {
    if (!isPartial) {
      setLine_items([])
    } else {
      setLine_items([lineItem])
    }
  }, [isPartial, lineItem])

  const [errors, setErrors] = React.useState({})

  React.useEffect(() => {
    const newErrors: any = {}

    if (isPartial) {
      if (!lineItem?.name) {
        newErrors.name = '**Required'
      }
      if (!lineItem?.price) {
        newErrors.price = '**Required'
      }

      if (lineItem?.price > balance && balance > 0) {
        newErrors.price = `Maximum valid amount is ${balance}`
      }

      if (balance <= 0) {
        newErrors.price = `You don't have payment balance`
      }
    }
    setErrors(newErrors)
  }, [isPartial, lineItem, balance])

  return (
    <CoreProvider value={{ line_items, lineItem, setLineItem, isPartial, setIsPartial, errors, balance, ...props }}>
      {children}
    </CoreProvider>
  )
}

export const useContext = () => useContextCore(context)
